
<template>
  <div class="w-full flex justify-center">
    <!-- inicio de contenido -->
    <div
      class="w-full bg-white mt-5 sm:mt-10 md:ml-20 md:mr-20"      
    >
      <template v-if="hasSlug">
          <!--TABS-->
          <TabsComponent
            id="profile"
            v-model="activeTab"
            :tabs="tabs"
          >
            <template #tab-profile>
              <svg class="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
                <path d="M7.99968 1.83398C6.68114 1.83398 5.3922 2.22498 4.29588 2.95752C3.19955 3.69006 2.34506 4.73125 1.84048 5.94943C1.3359 7.1676 1.20387 8.50805 1.46111 9.80125C1.71834 11.0945 2.35328 12.2823 3.28563 13.2147C4.21798 14.147 5.40587 14.782 6.69908 15.0392C7.99228 15.2965 9.33273 15.1644 10.5509 14.6598C11.7691 14.1553 12.8103 13.3008 13.5428 12.2045C14.2754 11.1081 14.6663 9.81919 14.6663 8.50065C14.6644 6.73314 13.9614 5.03857 12.7116 3.78875C11.4618 2.53893 9.76719 1.83593 7.99968 1.83398ZM7.99968 5.16732C8.39524 5.16732 8.78192 5.28462 9.11082 5.50438C9.43972 5.72414 9.69606 6.0365 9.84744 6.40195C9.99881 6.7674 10.0384 7.16954 9.96125 7.5575C9.88408 7.94546 9.6936 8.30183 9.41389 8.58153C9.13419 8.86124 8.77782 9.05172 8.38986 9.12889C8.0019 9.20606 7.59976 9.16645 7.23431 9.01508C6.86886 8.8637 6.5565 8.60736 6.33674 8.27846C6.11698 7.94956 5.99968 7.56288 5.99968 7.16732C5.99968 6.63688 6.21039 6.12818 6.58546 5.7531C6.96054 5.37803 7.46924 5.16732 7.99968 5.16732ZM7.99968 13.834C6.82582 13.8353 5.67767 13.4902 4.69901 12.842C4.77636 12.1974 5.08696 11.6034 5.5722 11.172C6.05745 10.7407 6.68378 10.5019 7.33301 10.5007H8.66634C9.31558 10.5019 9.94191 10.7407 10.4272 11.172C10.9124 11.6034 11.223 12.1974 11.3003 12.842C10.3217 13.4902 9.17354 13.8353 7.99968 13.834Z" fill="currentColor"/>
              </svg>Mi Perfil
            </template>
            <template #tab-address>
              <svg class="w-4 h-4 me-2 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor">
                <path d="M8.00048 9.83275C7.47306 9.83275 6.95749 9.67635 6.51896 9.38333C6.08043 9.09031 5.73863 8.67384 5.5368 8.18657C5.33496 7.6993 5.28216 7.16312 5.38505 6.64584C5.48794 6.12856 5.74192 5.6534 6.11486 5.28046C6.4878 4.90752 6.96295 4.65355 7.48024 4.55065C7.99752 4.44776 8.5337 4.50057 9.02097 4.7024C9.50824 4.90423 9.92471 5.24603 10.2177 5.68456C10.5107 6.12309 10.6671 6.63866 10.6671 7.16608C10.6671 7.87332 10.3862 8.5516 9.8861 9.0517C9.386 9.55179 8.70772 9.83275 8.00048 9.83275ZM8.00048 5.83275C7.73677 5.83275 7.47898 5.91094 7.25972 6.05745C7.04045 6.20396 6.86955 6.4122 6.76864 6.65583C6.66772 6.89947 6.64132 7.16756 6.69276 7.4262C6.74421 7.68484 6.8712 7.92242 7.05767 8.10889C7.24414 8.29536 7.48172 8.42235 7.74036 8.47379C7.999 8.52524 8.26709 8.49884 8.51072 8.39792C8.75436 8.297 8.96259 8.12611 9.1091 7.90684C9.25561 7.68757 9.33381 7.42979 9.33381 7.16608C9.33381 6.81246 9.19333 6.47332 8.94329 6.22327C8.69324 5.97322 8.3541 5.83275 8.00048 5.83275Z" fill="currentColor"/>
                <path d="M8.00048 15.1661C7.90205 15.166 7.80485 15.1442 7.71586 15.1021C7.62688 15.06 7.54831 14.9988 7.48581 14.9227L3.98914 10.6734C3.92248 10.5987 3.84648 10.5054 3.77181 10.4067L3.69181 10.3094C3.66076 10.2718 3.63393 10.2309 3.61181 10.1874C3.0627 9.39119 2.74044 8.46064 2.67953 7.49535C2.61863 6.53006 2.82136 5.56638 3.26605 4.70746C3.71073 3.84854 4.38061 3.12671 5.204 2.61923C6.02738 2.11176 6.97327 1.83775 7.94041 1.82653C8.90756 1.81531 9.85955 2.06731 10.6945 2.55554C11.5294 3.04377 12.2159 3.74987 12.6804 4.59825C13.1448 5.44662 13.3699 6.40534 13.3314 7.37178C13.2929 8.33822 12.9923 9.276 12.4618 10.0847C12.44 10.1306 12.4127 10.1736 12.3805 10.2127L12.2958 10.3161C12.1766 10.4791 12.048 10.6349 11.9105 10.7827L8.51581 14.9194C8.45356 14.9961 8.37503 15.0581 8.28591 15.1007C8.19678 15.1434 8.09929 15.1657 8.00048 15.1661ZM4.78381 9.54075L4.81514 9.57875C4.88181 9.66875 4.94381 9.74008 5.00514 9.80941L8.00048 13.4494L10.9058 9.91075C11.0252 9.78218 11.1365 9.64637 11.2391 9.50408L11.2891 9.44341L11.3065 9.41608C11.7188 8.81145 11.9574 8.10527 11.9962 7.37444C12.035 6.6436 11.8726 5.91613 11.5266 5.27123C11.1806 4.62632 10.6643 4.0887 10.0339 3.71691C9.4035 3.34512 8.68319 3.1534 7.95138 3.16264C7.21958 3.17187 6.50433 3.3817 5.88352 3.76928C5.26272 4.15686 4.76014 4.70734 4.43052 5.36077C4.1009 6.0142 3.95686 6.74554 4.0141 7.47516C4.07134 8.20478 4.32766 8.90471 4.75514 9.49875C4.76581 9.51297 4.77537 9.52697 4.78381 9.54075Z" fill="currentColor"/>
              </svg>Mi Ubicación
            </template>
            <template #tab-networks>
              <svg class="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="currentColor">
                <path d="M14.5 7.57348C14.4979 7.01671 14.3108 6.47631 13.968 6.03678C13.6252 5.59725 13.146 5.28335 12.6053 5.14416V3.75886C12.6052 3.52754 12.5412 3.30072 12.4203 3.10327C12.2994 2.90582 12.1263 2.74538 11.92 2.63955C11.7137 2.53371 11.4822 2.48657 11.2508 2.5033C11.0194 2.52002 10.797 2.59997 10.6082 2.73436L7.35053 5.05475H3.76316C3.42815 5.05475 3.10686 5.18743 2.86997 5.42361C2.63308 5.65979 2.5 5.98011 2.5 6.31412V8.83285C2.5 9.16685 2.63308 9.48718 2.86997 9.72336C3.10686 9.95953 3.42815 10.0922 3.76316 10.0922V13.2406C3.76316 13.5746 3.89624 13.895 4.13313 14.1311C4.37002 14.3673 4.69131 14.5 5.02632 14.5H5.65789C5.9929 14.5 6.31419 14.3673 6.55108 14.1311C6.78797 13.895 6.92105 13.5746 6.92105 13.2406V10.0922H7.35053L10.6076 12.412C10.7964 12.5465 11.0188 12.6266 11.2503 12.6435C11.4818 12.6603 11.7135 12.6132 11.9199 12.5073C12.1263 12.4015 12.2995 12.2409 12.4204 12.0434C12.5413 11.8458 12.6053 11.6189 12.6053 11.3875V10.0022C13.1459 9.86301 13.625 9.54921 13.9678 9.1098C14.3106 8.6704 14.4978 8.13015 14.5 7.57348ZM3.76316 6.31412H6.92105V8.83285H3.76316V6.31412ZM5.65789 13.2406H5.02632V10.0922H5.65789V13.2406ZM11.3421 11.3875L8.18421 9.13825V6.00809L11.3421 3.75571V11.3875ZM12.6053 8.66346V6.4835C12.797 6.59412 12.9561 6.75306 13.0668 6.94437C13.1774 7.13568 13.2357 7.35264 13.2357 7.57348C13.2357 7.79432 13.1774 8.01128 13.0668 8.20259C12.9561 8.3939 12.797 8.55284 12.6053 8.66346Z" fill="currentColor"/>
              </svg>Redes Sociales
            </template>
            <template #tab-security>
              <svg class="w-4 h-4 me-2 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M12.0003 6.2H11.0003V4.7C11.0003 3.98392 10.6843 3.29716 10.1216 2.79081C9.55904 2.28446 8.79598 2 8.00033 2C7.20468 2 6.44161 2.28446 5.87901 2.79081C5.3164 3.29716 5.00033 3.98392 5.00033 4.7V6.2H4.00033C3.6467 6.2 3.30756 6.32643 3.05752 6.55147C2.80747 6.77652 2.66699 7.08174 2.66699 7.4V12.8C2.66699 13.1183 2.80747 13.4235 3.05752 13.6485C3.30756 13.8736 3.6467 14 4.00033 14H12.0003C12.3539 14 12.6931 13.8736 12.9431 13.6485C13.1932 13.4235 13.3337 13.1183 13.3337 12.8V7.4C13.3337 7.08174 13.1932 6.77652 12.9431 6.55147C12.6931 6.32643 12.3539 6.2 12.0003 6.2ZM6.33366 4.7C6.33366 4.30218 6.50925 3.92064 6.82181 3.63934C7.13438 3.35804 7.5583 3.2 8.00033 3.2C8.44235 3.2 8.86628 3.35804 9.17884 3.63934C9.4914 3.92064 9.66699 4.30218 9.66699 4.7V6.2H6.33366V4.7ZM12.0003 12.8H4.00033V7.4H12.0003V12.8Z" fill="currentColor"/>
                <path d="M8.00033 8.6C7.82351 8.6 7.65395 8.66321 7.52892 8.77574C7.4039 8.88826 7.33366 9.04087 7.33366 9.2V11C7.33366 11.1591 7.4039 11.3117 7.52892 11.4243C7.65395 11.5368 7.82351 11.6 8.00033 11.6C8.17714 11.6 8.34671 11.5368 8.47173 11.4243C8.59675 11.3117 8.66699 11.1591 8.66699 11V9.2C8.66699 9.04087 8.59675 8.88826 8.47173 8.77574C8.34671 8.66321 8.17714 8.6 8.00033 8.6Z" fill="currentColor"/>
              </svg>Seguridad
            </template>
          </TabsComponent>
          <div>
            <div v-show="activeTab === 'profile'">
              <FormAgentComponent
                :property-id="id"
                @trigger-update-property="updateProperty"
              />
            </div>
            <div v-show="activeTab === 'networks'">
              <FormNetworksComponent
              />
            </div>
            <div v-show="activeTab === 'address'">
              <FormLocationComponent
                :resp="data_broker"
                :property-id="id"
                Type="agent" 
              />
            </div>
            <div v-show="activeTab === 'security'">
              <FormSecurityComponent
              />
            </div>
          </div>
        </template>
    </div>
  </div>
</template>
<script setup>

import {
  //FwbTab,
  //FwbTabs,
  //FlowbiteThemable,
} from "flowbite-vue";
import { ref, onMounted, watch, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import FormAgentComponent from "./FormAgentComponent.vue";
import FormLocationComponent from "./FormLocationComponent.vue";
import FormNetworksComponent from "./FormNetworksComponent.vue";
import FormSecurityComponent from "./FormSecurityComponent.vue";
import TabsComponent from "@/components/common/TabsComponent.vue";
import { useStore } from "vuex";
import axios from "axios";

//const theme = 'pink' // 'blue', 'green', 'red', 'pink', 'purple'
const store = useStore();
let session = computed(() => store.getters.getUserSession);
// Acceder al parámetro 'id' de la URL directamente
const route = useRoute();
let id = session.value.id;
let active_tab = ref(true);
let router = useRouter();
const activeTab = ref("profile");
const tabs = [
  { value: 'profile', label: 'Mi Perfil' },
  { value: 'address', label: 'Mi Ubicación' },
  { value: 'networks', label: 'Redes Sociales' },
  { value: 'security', label: 'Seguridad' }
];
let step = ref(3);
let data_broker = ref({});
const hasSlug = ref(false); 

onMounted(async () => {
  if (id != undefined) {
    active_tab.value = true;
  }
});

async function getProfile() {
  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${session.value.id}`,
      options
    );

    if (response.status == 200) {
      data_broker.value = response;
    }
  } catch (error) {
    let response = error.response ;
    if(response.status == 401){
      store.dispatch("clearUserSession"); 
      router.push({ name: 'login' });
    }
    console.error("Error fetching data:", error.response);
  }
}

/*async function updateProperty(property_id){
  console.log('actualiza estado de tabs', property_id)
  active_tab.value = true;
}*/
onMounted(async () => {
    try {
      await getProfile();
      // Modificamos la ruta para acceder correctamente al slug
      hasSlug.value = data_broker.value?.data?.resp?.info?.slug ? true : false;
      step.value = session.value.step;
    } catch (error) {
      console.error("Error al intentar traer los datos", error);
    }
});
watch(activeTab, async (newTab) => {
    if (newTab === 'first') {
      await getProfile(); // Al seleccionar "Datos generales", cargamos los datos de la compañía
    }
  });
watch(
  () => route.params.id,
  (newId) => {
      id =  newId
  }
);

</script>
